.c6{max-width:100%;}